var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 1.66667C6.31808 1.66667 3.33331 5.00216 3.33331 8.75C3.33331 12.4685 5.46108 16.5103 8.78087 18.062C9.55477 18.4238 10.4452 18.4238 11.2191 18.062C14.5389 16.5103 16.6666 12.4685 16.6666 8.75C16.6666 5.00216 13.6819 1.66667 9.99998 1.66667ZM9.99998 10C10.9205 10 11.6666 9.25381 11.6666 8.33334C11.6666 7.41286 10.9205 6.66667 9.99998 6.66667C9.0795 6.66667 8.33331 7.41286 8.33331 8.33334C8.33331 9.25381 9.0795 10 9.99998 10Z",
    fill: "#F67C36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationFilled);
export default __webpack_public_path__ + "static/media/location_filled.4627540b0ef7267ef057c41c573c4b54.svg";
export { ForwardRef as ReactComponent };